import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { useBreakpointContext } from '../../context-providers/BreakpointProvider';
import { ModalContext } from '../../context-providers/ModalProvider';
import { chartStore } from '../../stores/ChartStore';
import { marketsStore } from '../../stores/MarketsStore';
import CryptoIcon from '../CryptoIcon/CryptoIcon';
import SelectMarket from '../modals/SelectMarket/SelectMarket';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Toolbar.scss';
import {formatPrice} from "../../helpers/formatters";
import {baseAssetOverride} from "../trade-tabs/helpers/position-columns";

const Toolbar = observer(() => {
    const { openModal } = useContext(ModalContext);
    const currentMarket = marketsStore.currentMarket;
    const { xs } = useBreakpointContext();

    const openSelectMarket = () => {
        openModal(<SelectMarket/>);
    };

    let baseAsset = currentMarket?.baseAsset
    if (xs && currentMarket?.baseAsset) {
        baseAsset = baseAssetOverride(currentMarket?.baseAsset)
    }
    const marketName = currentMarket ? `${baseAsset}/${currentMarket?.quoteAsset}` : ''
    return (
        <div className={`Toolbar flex mb-4 ${!xs ? 'card-container' : ''}`}>
            <div className={`Toolbar__part Toolbar__left-part flex ${xs ? 'card-container mb-2' : ''}`}>
                <div className="Toolbar__dropdown flex items-center py-1.5" onClick={openSelectMarket}>
                    <div className="mr-3"><CryptoIcon ticker={currentMarket?.baseAsset || ''} size={28}/></div>
                    <div className="flex flex-col items-start">
                        <div className={`flex ${xs ? 'flex-col' : ''}`}>
                            {xs && !!currentMarket?.popular && (
                                <div className="label-popular mb-1" style={{width: '64px'}}>Popular</div>
                            )}
                            <div className="Toolbar__dropdown__marketName uppercase nereus-body-m">
                                {marketName}
                            </div>
                            {!xs && !!currentMarket?.popular && (
                                <div className="label-popular ml-2">Popular</div>
                            )}
                        </div>
                        {currentMarket && (
                            <div className="Toolbar__dropdown__description nereus-color-neutral-grey nereus-caption">
                                Up to {marketsStore.currentMarketMaxLeverage}x
                            </div>
                        )}
                    </div>
                    <div className="ml-2"><ExpandMoreIcon style={{ color: 'white' }}/></div>
                </div>
                <div className="Toolbar__price nereus-title-m">
                    ${marketsStore.latestPrice > 0 ? formatPrice(marketsStore.latestPrice): ''}
                </div>
            </div>

            <div className={`Toolbar__part Toolbar__right-part flex ${xs ? 'card-container' : ''}`}>
                {chartStore.dailyStats?.change !== undefined && (
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">24h Change</label>
                        <div
                            className={`nereus-body-m ${chartStore?.dailyStats?.change >= 0 ? 'nereus-color-up' : 'nereus-color-down'}`}>{chartStore.dailyStats?.change?.toFixed(2)}%
                        </div>
                    </div>
                )}
                {chartStore.dailyStats?.low && (
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">24h Low</label>
                        <div className="nereus-body-m">{formatPrice(chartStore.dailyStats?.low)}</div>
                    </div>
                )}
                {chartStore.dailyStats?.high && (
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">24h High</label>
                        <div className="nereus-body-m">{formatPrice(chartStore.dailyStats?.high)}</div>
                    </div>
                )}
            </div>
        </div>
    );
});

export default Toolbar;